import { SET_FILTER, RESET_FILTERES, SET_FILTERS } from "./constants";
import initialState from "./initialState";

function sortFilters(a, b) {
	let item1 = a;
	let item2 = b;
	if (a.key) {
		item1 = a.key;
		item2 = b.key;
	}
	if (item1 === "ST" || item2 === "ST" || item1 === "st" || item2 === "st") {
		return -1;
	}
	if (item1 < item2) {
		return -1;
	}
	if (item1 > item2) {
		return 1;
	}
	return 0;
}

const setUpUrl = function(state, action) {
	const { href } = window.location;
	const filters = Object.keys(state[action.building])
		.reduce((all, name) => {
			const filter =
				typeof state[action.building][name] === "string"
					? // && state[action.building][name].length >= 0
					  state[action.building][name]
					: state[action.building][name].join(",");
			if (filter.length > 0) {
				all.push(`${name}=${filter}`);
			}
			return all;
		}, [])
		.join("&");

	window.location.href = `${href.split("?")[0]}?${filters}`;
};

export default (state = JSON.parse(JSON.stringify(initialState)), action) => {
	let checked = 0;
	const resetState = {
		...JSON.parse(JSON.stringify(initialState))
	};
	switch (action.type) {
		case SET_FILTERS:
			return {
				...action.filters
			};
		case RESET_FILTERES:
			return {
				...resetState
			};
		case SET_FILTER:
			if (action.filterType === "checkbox") {
				if (
					action.filterName === "floor" &&
					typeof state[action.building][action.filterName] === "string"
				) {
					state[action.building][action.filterName] = [];
				}

				checked = state[action.building][action.filterName].indexOf(
					action.value
				);
				if (checked > -1) {
					state[action.building][action.filterName].splice(checked, 1);
				} else {
					state[action.building][action.filterName].push(action.value);
				}

				if (action.filterName === "type") {
					state[action.building][action.filterName].sort(sortFilters);
				}
			} else {
				state[action.building][action.filterName] = action.value;
			}
			setUpUrl(state, action);
			return {
				...state
			};

		default:
			return state;
	}
};
